export default {
    yourAnswer: "Ihre Antwort",
    answerFrom: "Antwort von",
    yourQuantityAnswer: "Menge angeben",
    quantityAnswerFrom: "Mengenangabe von",
    yourDateAnswer: "Datum angeben",
    dateAnswerFrom: "Datumangabe von",
    notAvailable: "Nicht mehr verfügbar",

    test: "Test Validation"
}
